import * as React from "react";

import { Navigate, useLocation } from "react-router-dom";
import moment from "moment";

import { useAppSelector } from "../../redux/hooks";

interface IAuthenticatedRouteProps {
  children: JSX.Element;
  adminOnly?: boolean;
}

export const AuthenticatedRoute: React.FC<IAuthenticatedRouteProps> = ({
  children,
  adminOnly = false,
}) => {
  const location = useLocation();
  const { isAuthenticated, exp, authority } = useAppSelector((state) => state.auth);
  if (!isAuthenticated || moment.unix(exp) < moment(new Date())) {
    localStorage.clear();
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (adminOnly && authority !== "ADMIN" && authority !== "SUPER_ADMIN") {
    return <Navigate to="/" replace />;
  }

  return children;
};
